import * as R from 'ramda';

export const isOpen = ({ deleteCutTicket }) => !!deleteCutTicket.cutTicket;
export const isSubmiting = ({ deleteCutTicket }) => deleteCutTicket.submiting;
export const canSave = ({ deleteCutTicket }) => !deleteCutTicket.submiting;
export const getCutTicket = ({ deleteCutTicket }) => R.path(['cutTicket'], deleteCutTicket);
